<!-- <div class="before-tooltip" [class.query-tooltip]="beforeTooltipMode === 'query'" *ngIf="beforeTooltipVisible" [style.left.px]="beforeTooltipX" [style.top.px]="beforeTooltipY">{{ beforeTooltipText }}</div> -->
@if (beforeTooltipVisible) {
  <div
    class="before-tooltip"
    [class.query-tooltip]="beforeTooltipMode === 'query'"
    [style.left.px]="beforeTooltipX"
    [style.top.px]="beforeTooltipY"
  >
    @if (beforeTooltipMode === "query") {
      <div [innerHTML]="beforeTooltipHtml"></div>
    } @else {
      {{ beforeTooltipText }}
    }
  </div>
}
<div class="sql-runner-container">
  <as-split direction="vertical" unit="percent" [gutterSize]="6">
    <as-split-area [size]="45">
      <div class="top">
        <div class="toolbar">
          <button
            mat-button
            class="toolbar-rect-btn"
            floatingTooltip="Execute SQL"
            type="button"
            (click)="executeSql()"
          >
            <mat-icon>play_arrow</mat-icon>
          </button>
          <button
            mat-button
            class="toolbar-rect-btn"
            floatingTooltip="Load SQL file"
            type="button"
            (click)="fileInput.click()"
          >
            <mat-icon>folder_open</mat-icon>
          </button>
          <button
            mat-button
            class="toolbar-rect-btn"
            floatingTooltip="Save SQL file"
            type="button"
            (click)="saveSqlFile()"
          >
            <mat-icon>save</mat-icon>
          </button>
          <button
            mat-button
            class="toolbar-rect-btn"
            floatingTooltip="Copy Order"
            type="button"
            (click)="openCopyOrderDialog()"
            style="background-color: #d35400"
          >
            <mat-icon>content_copy</mat-icon>
          </button>
          <button
            mat-button
            class="toolbar-rect-btn"
            floatingTooltip="Open Active Order CC Form"
            type="button"
            (click)="openActiveOrderCCForm(null)"
            style="background-color: #d35400"
          >
            <mat-icon>edit</mat-icon>
          </button>
          <button
            mat-button
            class="toolbar-rect-btn"
            floatingTooltip="Manage Country Regulations"
            type="button"
            (click)="$event.currentTarget.blur(); openCountryRegulationsManager()"
            style="background-color: #d35400"
          >
            <mat-icon>public</mat-icon>
          </button>
          <input #fileInput id="sqlFileInput" name="sqlFileInput" aria-label="Load SQL file" type="file" accept=".sql" style="display: none" (change)="loadSqlFile($event)" />
          <!-- =============================
          QUERY HISTORY (CUSTOM)
          ============================= -->
          <div class="query-picker" (clickOutside)="closeQueryList()">
            <div class="query-picker-control" (click)="toggleQueryList()">
              <mat-icon class="query-icon">history</mat-icon>
              <span class="placeholder">Queries</span>
              <mat-icon class="chevron">expand_more</mat-icon>
            </div>
            @if (queryListOpen) {
              <div class="query-list">
                @for (q of queryHistory; track q) {
                  <div class="query-item" (click)="applyQuery(q)">
                    <input
                      type="checkbox"
                      name="defaultQueryCheckbox"
                      aria-label="Set default query"
                      class="default-query-checkbox"
                      [checked]="defaultQuery === q"
                      [floatingTooltip]="'Check to set by default'"
                      (mouseenter)="hideBeforeTooltip()"
                      (click)="toggleDefaultQuery(q, $event)"
                    />
                    <span
                      class="query-text"
                      (mouseenter)="showQueryTooltip($event, q)"
                      (mouseleave)="hideBeforeTooltip()"
                      (mousemove)="moveTooltip($event)"
                    >
                      @if (parseQuery(q); as p) {
                        {{ p.before }}
                        <span class="query-table">{{ p.table }}</span>
                        @if (p.after) {
                          <span> …</span>
                        }
                      }
                    </span>
                    <button type="button" class="copy-btn delete-btn" (click)="deleteQuery(q, $event)">
                      <span class="copy-icon material-icons">delete</span>
                    </button>
                  </div>
                }
                @if (!queryHistory.length) {
                  <div class="query-empty">No saved queries</div>
                }
              </div>
            }
          </div>
          <!-- ============================= -->
          <div class="search-box">
            <mat-icon class="search-icon">search</mat-icon>
            <input id="searchText" name="searchText" aria-label="Search in results" #searchInput type="text" placeholder="Search in results…" [(ngModel)]="searchText" />
          </div>
          <div
            [style.boxShadow]="
              authState === 'ok'
                ? '0 0 0 3px #4caf50'
                : authState === 'error'
                  ? '0 0 0 3px #f44336'
                  : '0 1px 3px rgba(0,0,0,0.15)'
            "
            [style.transform]="shakeOffset"
            style="
              display: flex;
              align-items: center;
              background: white;
              border-radius: 6px;
              padding: 6px 10px;
              margin-left: 12px;
              transition:
                box-shadow 0.2s,
                transform 0.05s;
            "
          >
            <mat-icon style="margin-right: 6px; color: #555">key</mat-icon>
            <input
              id="keyInput"
              name="keyValue"
              aria-label="Authentication key"
              #keyInput
              type="text"
              placeholder="key"
              [(ngModel)]="keyValue"
              autocomplete="off"
              autocorrect="off"
              autocapitalize="off"
              spellcheck="false"
              [style.-webkit-text-security]="showKey ? 'none' : 'disc'"
              style="border: none; outline: none; font-size: 14px; width: 120px; background: transparent"
            />
            <mat-icon (click)="toggleShowKey()" style="cursor: pointer; margin-left: 6px; color: #777">
              {{ showKey ? "visibility_off" : "visibility" }}
            </mat-icon>
          </div>
          <mat-form-field appearance="outline" class="server-select-field">
            <mat-icon matPrefix class="server-icon">dns</mat-icon>
            <mat-select [(value)]="selectedServer" panelClass="server-select-panel" disableOptionCentering>
              <mat-option [value]="0">CUBI</mat-option>
              <mat-option [value]="1">GLOBEX</mat-option>
            </mat-select>
          </mat-form-field>
          <div class="data-info">
            <span>Row count: {{ rows.length }}</span>
            <button
              type="button"
              class="warnings-toggle"
              (click)="toggleWarningFilter()"
              [class.on]="showWarningsOnly"
              [attr.aria-pressed]="showWarningsOnly"
            >
              <span class="warnings-toggle-icon">⚠</span>
              <span class="text">
                {{ showWarningsOnly ? "Show all items" : "Show warnings only" }}
              </span>
              <span class="count">{{ showWarningsOnly ? allCount : warningCount }}</span>
            </button>
          </div>
        </div>
        <textarea id="sqlEditor" name="sqlEditor" aria-label="SQL editor" #sqlEditor style="display: none"></textarea>
        <div #sqlEditorHost class="sql-editor"></div>
      </div>
    </as-split-area>
    <as-split-area [size]="55">
      <div class="bottom">
        <div class="grid-container">
          <!-- HEADER (unchanged, proven to work) -->
          @if (tableReady) {
            <div class="table-header-viewport">
              <table
                class="result-table"
                [style.width.px]="totalTableWidth"
                [style.transform]="'translateX(' + -gridScrollLeft + 'px)'"
              >
                <colgroup>
                  @for (w of columnWidths; track w) {
                    <col [style.width.px]="w" />
                  }
                </colgroup>
                <thead>
                  <tr>
                    @for (col of columns; track col; let i = $index) {
                      <th>
                      <div class="th-inner">
                        <span class="th-text">{{ col }}</span>
                        <span class="th-indicators">
                          @if (i === 0) {
                            <button
                              type="button"
                              class="th-indicator-btn json-indicator"
                              [floatingTooltip]="'Show grid result as formatted JSON'"
                              (click)="openGridJson(); $event.stopPropagation()"
                            >
                              <span class="material-icons">data_object</span>
                            </button>
                          }
                          <!-- VISUAL INDICATOR : KEY -->
                          @if (col === "SHO_ID") {
                            <span
                              class="th-indicator key-indicator material-icons"
                              [floatingTooltip]="shopifyKeyHeaderTooltip"
                            >
                              key
                            </span>
                          }
                          <!-- VISUAL INDICATOR : PRICE -->
                          @if (col === "SHO_CubiResponse") {
                            <span
                              class="th-indicator price-indicator material-icons"
                              [floatingTooltip]="priceBreakdownHeaderTooltip"
                            >
                              attach_money
                            </span>
                          }
                        </span>
                      </div>
                        <span class="col-resizer" (mousedown)="startResize($event, i)"></span>
                      </th>
                    }
                  </tr>
                </thead>
              </table>
            </div>
          }
          <!-- VIRTUALIZED BODY (DIV BASED) -->
          <cdk-virtual-scroll-viewport
            class="table-viewport"
            [itemSize]="ROW_HEIGHT"
            (scroll)="syncGridHeader($event)"
          >
            <div
              class="table-row"
              *cdkVirtualFor="let row of rows; let rowIndex = index"
              [style.width.px]="totalTableWidth"
              [class.active-row]="isActiveRow(rowIndex)"
            >
              @for (col of columns; track col; let colIndex = $index) {
                <div
                  class="table-cell"
                  [style.width.px]="columnWidths[colIndex]"
                  (mousedown)="activateCell(rowIndex, colIndex, $event)"
                  [class.search-hit]="searchFocus?.rowIndex === rowIndex && searchFocus?.colIndex === colIndex"
                >
                  <!-- JSON -->
                  @if (isJson(row[col])) {
                    <span
                      class="json-link"
                      (click)="openJson(row[col]); $event.stopPropagation()"
                      (mouseenter)="showBeforeTooltip($event, col, row[col])"
                      (mouseleave)="hideBeforeTooltip()"
                      (mousemove)="moveTooltip($event)"
                      [class.json-before]="isResponseColumn(col) && hasBeforeValue(row[col])"
                    >
                      <span style="border: 0.4px solid rgba(178, 178, 178, 0.548); border-radius: 3px; padding: 3px"
                        >JSON</span
                      >
                    </span>
                  } @else {
                    <!-- XML -->
                    @if (isXml(row[col])) {
                      <span class="json-link" (click)="openXml(row[col]); $event.stopPropagation()"> [XML] </span>
                    } @else {
                      <!-- HTML -->
                      @if (isHtml(row[col])) {
                        <span class="json-link" (click)="openHtml(row[col]); $event.stopPropagation()">
                          <span style="color: red">[ERROR]</span>
                        </span>
                      } @else {
                        @if (colIndex === 0) {
                          <div class="first-col-cell">
                            <button
                              type="button"
                              class="row-json-btn"
                              [floatingTooltip]="'Show this row as formatted JSON'"
                              (mousedown)="$event.stopPropagation()"
                              (click)="openRowJson(row); $event.stopPropagation()"
                            >
                              <span class="material-icons">data_object</span>
                            </button>
                            <span>
                              {{ formatCellValue(row[col]) }}
                            </span>
                          </div>
                        } @else {
                          {{ formatCellValue(row[col]) }}
                        }
                      }
                    }
                  }
                  <!-- COPY + PRICE BUTTON -->
                  @if (activeCell?.rowIndex === rowIndex && activeCell?.colIndex === colIndex && col === "SHO_ID") {
                    <button type="button" class="key-btn" (click)="openShoKeyPopover($event, row)">
                      <span class="copy-icon material-icons">key</span>
                    </button>
                  }
                  <!-- BASE64 PREVIEW BUTTON -->
                  @if (
                    activeCell?.rowIndex === rowIndex &&
                    activeCell?.colIndex === colIndex &&
                    hasBase64Document(row[col])
                  ) {
                    <button type="button" class="preview-btn" (click)="openBase64Preview(row[col], $event)">
                      <span class="material-icons">visibility</span>
                    </button>
                  }
                  <!-- COPY BUTTON -->
                  @if (activeCell?.rowIndex === rowIndex && activeCell?.colIndex === colIndex) {
                    <button type="button" class="copy-btn" [class.copied]="copyFeedback" (click)="copyCell(row[col], $event)">
                      <span class="copy-icon material-icons">content_copy</span>
                    </button>
                  }
                  @if (
                    activeCell?.rowIndex === rowIndex && activeCell?.colIndex === colIndex && col === "SHO_CubiResponse"
                  ) {
                    <button type="button" class="price-btn" (click)="openPricePopup(row, $event)">
                      <span class="copy-icon material-icons">attach_money</span>
                    </button>
                  }
                </div>
              }
            </div>
          </cdk-virtual-scroll-viewport>
        </div>
      </div>
    </as-split-area>
  </as-split>
  <!-- JSON POPUP -->
  @if (jsonPopupVisible) {
    <div class="json-overlay">
      <div class="json-dialog">
        <div class="json-header">
          <span class="popup-title">JSON</span>
          <div class="search-box json-search-box">
            <mat-icon class="search-icon">search</mat-icon>
            <input id="jsonSearchText" name="jsonSearchText" aria-label="Search in JSON" type="text" placeholder="Search in JSON F3 (next)..." [(ngModel)]="jsonSearchText" />
          </div>
          <div class="json-header-actions">
            <button
              mat-raised-button
              type="button"
              class="json-action-btn json-copy-btn"
              floatingTooltip="Copy the entire JSON"
              (click)="copyEntireJson()"
            >
              <mat-icon>content_copy</mat-icon>
              Copy
            </button>
            <button
              mat-raised-button
              type="button"
              class="json-action-btn json-excel-btn"
              floatingTooltip="Export the entire JSON to Excel"
              (click)="exportJsonToExcel()"
            >
              <span class="excel-icon" aria-hidden="true">
                <svg viewBox="0 0 32 32" width="22" height="22">
                  <path fill="#107C41" d="M18 3h11v26H18z" />
                  <path fill="#185C37" d="M18 3h11v7H18z" />
                  <path fill="#21A366" d="M18 10h11v6H18z" />
                  <path fill="#107C41" d="M18 16h11v6H18z" />
                  <path fill="#33C481" d="M18 22h11v7H18z" />
                  <path fill="#107C41" d="M3 7l17-3v24L3 25z" />
                  <path fill="#fff" d="M8.1 11.2h3.5l2 3.8 2.1-3.8h3.3l-3.6 5.7 3.8 6h-3.5l-2.3-4.1-2.3 4.1H7.8l3.8-5.9z" />
                </svg>
              </span>
              Export to Excel
            </button>
            <button mat-raised-button color="primary" type="button" class="json-close-btn" (click)="closeJson()">
              <mat-icon>close</mat-icon>
              Close
            </button>
          </div>
        </div>
        <div #jsonTextContent class="json-content">
          @for (line of jsonLines; track line) {
            <div class="json-line" style="white-space: pre">
              {{ line.indent }}@switch (line.kind) {
                @case ("brace") {
                  <span class="json-brace">{{ line.text }}</span>{{ line.comma ? "," : "" }}
                }
                @case ("pair") {
                  <span class="json-key">"{{ line.key }}"</span>:
                  @if (line.valueType === "string") {
                    <span class="json-string">"{{ line.value }}"</span>
                  }
                  @if (line.valueType === "number") {
                    <span class="json-number">{{ line.value }}</span>
                  }
                  @if (line.valueType === "boolean") {
                    <span class="json-boolean">{{ line.value }}</span>
                  }
                  @if (line.valueType === "null") {
                    <span class="json-null">null</span>
                  }
                  {{ line.comma ? "," : "" }}
                }
                @case ("value") {
                  @if (line.valueType === "string") {
                    <span class="json-string">"{{ line.value }}"</span>
                  }
                  @if (line.valueType === "number") {
                    <span class="json-number">{{ line.value }}</span>
                  }
                  @if (line.valueType === "boolean") {
                    <span class="json-boolean">{{ line.value }}</span>
                  }
                  @if (line.valueType === "null") {
                    <span class="json-null">null</span>
                  }
                  {{ line.comma ? "," : "" }}
                }
                @case ("content") {
                  <span class="json-key">"{{ line.key }}"</span>:
                  <button type="button"
                    class="json-eye-btn"
                    (click)="
                      line.base64
                        ? openBase64File(line.base64!, line.fileName!)
                        : openShopifyVariantPreview(line.value!)
                    "
                  >
                    <span style="display: inline-flex; align-items: center; vertical-align: middle">
                      <svg viewBox="0 0 64 64" width="24" height="24">
                        <ellipse cx="32" cy="32" rx="28" ry="18" fill="#ffffff" />
                        <ellipse cx="32" cy="32" rx="26" ry="16" fill="#1e1e1e" />
                        <circle cx="32" cy="32" r="10" fill="#2ecc71" />
                        <circle cx="32" cy="32" r="5" fill="#000" />
                        <circle cx="36" cy="28" r="2" fill="#fff" />
                      </svg>
                    </span>
                  </button>
                  <span class="json-string"
                    >"{{ line.value | slice: 0 : 64 }}{{ line.value!.length > 64 ? "…" : "" }}"</span
                  >{{ line.comma ? "," : "" }}
                }
              }
            </div>
          }
        </div>
      </div>
    </div>
  }
  <!-- XML POPUP -->
  @if (xmlPopupVisible) {
    <div class="json-overlay">
      <div class="json-dialog">
        <div class="json-header">
          <span class="popup-title">XML</span>
          <div class="search-box">
            <mat-icon class="search-icon">search</mat-icon>
            <input id="xmlSearchText" name="xmlSearchText" aria-label="Search in XML" type="text" placeholder="Search in XML F3 (next)..." [(ngModel)]="xmlSearchText" />
          </div>
          <button mat-raised-button color="primary" type="button" (click)="closeXml()">
            <mat-icon>close</mat-icon>
            Close
          </button>
        </div>
        <pre #xmlTextContent class="json-content xml-content" [innerHTML]="xmlPopupContent"></pre>
      </div>
    </div>
  }
  <!-- HTML POPUP -->
  @if (htmlPopupVisible) {
    <div class="json-overlay">
      <div class="json-dialog">
        <div class="json-header">
          <span class="popup-title">HTML</span>
          <button mat-raised-button color="primary" type="button" (click)="closeHtml()">
            <mat-icon>close</mat-icon>
            Close
          </button>
        </div>
        <iframe title="HTML preview" class="html-frame" [attr.srcdoc]="htmlPopupContent"></iframe>
      </div>
    </div>
  }
  <!-- PRICE BREAKDOWN POPUP -->
  @if (pricePopupVisible) {
    <div class="json-overlay">
      <div class="price-dialog">
        <!-- HEADER -->
        <div class="price-header">
          <mat-icon class="price-icon">attach_money</mat-icon>
          <span class="price-title">PRICE BREAKDOWN</span>
        </div>
        <!-- CONTENT -->
        <div class="price-content">
          <div class="price-card">
            <pre>{{ buildPriceBreakdown(pricePopupRow) }}</pre>
          </div>
        </div>
        <!-- FOOTER -->
        <div class="price-footer">
          <button type="button" mat-raised-button color="primary" (click)="copyPriceBreakdown()">
            <mat-icon>content_copy</mat-icon>
            Copy
          </button>
          <button type="button" mat-raised-button color="primary" (click)="closePricePopup()">
            <mat-icon>close</mat-icon>
            Close
          </button>
        </div>
      </div>
    </div>
  }
  <!-- SHOPIFY PRODUCT PREVIEW POPUP -->
  @if (shopifyPreviewVisible) {
    <div class="json-overlay">
      <div class="shopify-preview-dialog">
        <!-- HEADER -->
        <div class="shopify-preview-header">
          <mat-icon class="preview-icon">visibility</mat-icon>
          <span class="preview-title">PREVIEW PRODUCT</span>
        </div>
        <!-- CONTENT -->
        <div class="shopify-preview-content">
          @if (shopifyPreviewImageUrl) {
            <img [src]="shopifyPreviewImageUrl" alt="Product preview" />
          }
        </div>
        <!-- FOOTER -->
        <div class="shopify-preview-footer">
          <button type="button" mat-raised-button color="primary" (click)="closeShopifyPreview()">
            <mat-icon>close</mat-icon>
            CLOSE
          </button>
        </div>
      </div>
    </div>
  }
  <!-- SHOPIFY KEY POPUP -->
  @if (shoKeyPopoverVisible) {
    <div class="sho-key-popover" [style.left.px]="shoKeyPopoverX" [style.top.px]="shoKeyPopoverY">
      <button type="button" class="sho-key-close" (click)="closeShoKeyPopover()" aria-label="Close">✕</button>
      <div class="sho-key-label">SHO Key</div>
      <div class="sho-key-value">{{ shoKeyValue }}</div>
      <button type="button" (click)="copyShoKey()">Copy</button>
    </div>
  }
</div>
@if (isProcessing) {
  <div class="processing-wrapper">
    <div class="processing-circle"></div>
    <div class="processing-text">
      {{ "app.misc.processing" | translate }}
    </div>
    <button type="button" class="processing-stop-button" (click)="stopExecuteSql()" [disabled]="!isProcessing">
      Stop current query
    </button>
  </div>
}
